import { useEffect, useMemo, useState } from "react";

/**
 * @module useTextInputHook
 * Controlled-input state hook for {@link TextCellWithInput} table cells.
 */

/**
 * Local state for {@link TextCellWithInput} controlled inputs.
 *
 * Syncs `inputValue` when `defaultValue` or `rowId` change so rows keyed by
 * index (tableBody) do not show stale text after J-code rows reorder.
 *
 * @param defaultValue - Prop-driven cell text (`value.data`).
 * @param rowId - Stable row identifier (`value.id`); resets input when the cell
 *   is reused for a different J-code at the same table index.
 * @returns Controlled input value, setter, and empty-check helper.
 */
export const useTextInputHook = (defaultValue: string, rowId?: string) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue, rowId]);

  const checkIfInputIsEmpty = useMemo(() => {
    return inputValue.trim() === "";
  }, [inputValue]);
  return {
    inputValue,
    setInputValue,
    checkIfInputIsEmpty,
  };
};
